import { environment } from "@/environments/environment";

export const BASE_URL_MANAGER = environment.vueAppAPI;
export const BASE_URL_ORCHESTATOR = environment.vueAppAPIOrchestrator;
export const BASE_URL_DROPI = environment.dropiAPI;
export const BASE_URL_WHATSAPP_CLOUD = environment.whatsappCloud;
